export const BoxBackgroundColor = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  NEGATIVE: 'negative',
  POSITIVE: 'positive',
  ATTENTION: 'attention',
  MONO_100: 'mono_100',
  MONO_200: 'mono_200',
  MONO_900: 'mono_900'
};